import { PayloadAction } from "@reduxjs/toolkit";

import { ApplicationState } from "../../types";

export const setFeatureFlags = (
  state: ApplicationState,
  action: PayloadAction<ApplicationState['featureFlags']['data']>
) => {
  state.featureFlags.data = action.payload;
};
